// extracted by mini-css-extract-plugin
export default {"cardSwipeBtnContainer":"SwipeBtnDesktop_cardSwipeBtnContainer__pEYIE","btn":"SwipeBtnDesktop_btn__SABAA"};